module.exports = __webpack_public_path__ + "img/javaMobile.5dfcf3d0.jpg";